import React from 'react';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import styled from '@emotion/styled';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

const PickerWrapper = styled.div`
 
  .react-daterange-picker__wrapper {
    background: #25253C;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: #fff;
    padding: 4px 8px;
    display: flex;
    align-items: center;
    gap: 4px; /* Increased gap between start and end date */
    z-index: 1001;
  }

  .react-daterange-picker__range-divider {
    font-size: 1.2em;
    color: #f43f60;
    font-weight: 700;
  }
  .react-daterange-picker__inputGroup input {
    background: transparent;
    color: #fff;
    border: none;
    font-size: 1rem;
    font-family: 'Clash Grotesk', sans-serif;
  }
  .react-daterange-picker__calendar {
    background: #1E1E35;
    border-radius: 16px;
    border: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    color: #fff;
    font-family: 'Clash Grotesk', sans-serif;
    z-index: 1001;
  }
  .react-calendar {
    background: #1E1E35;
    border-radius: 16px;
    border: none;
    color: #fff;
    font-family: 'Clash Grotesk', sans-serif;
    padding: 12px;
  }
  .react-calendar__tile {
    background: none !important;
    color: #fff;

    font-size: 1.1rem;
    width: 40px;
    height: 40px;
    margin: 2px auto;
    transition: background 0.2s, color 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Clash Grotesk', sans-serif;
    font-weight: 400;
    &:hover {
      background: #4BBBE4 !important;
      color: #fff;
    }
  }
  .react-calendar__tile--active,
  .react-calendar__tile--rangeStart,
  .react-calendar__tile--rangeEnd,
  .react-calendar__tile--rangeBothEnds {
    background: #313151 !important;
    color: #fff !important;
    font-weight: 600;
  }
  .react-calendar__tile--inRange {
    background: rgba(244, 63, 96, 0.18) !important;
    color: #fff;
  }
  .react-calendar__tile--now {
    background: rgba(244, 63, 96, 0.2);
    color: #fff;
  }
  .react-calendar__tile:disabled {
    color: #444;
    background: none;
    opacity: 0.4;
    cursor: not-allowed;
  }
    .react-calendar__navigation button:hover {
       background: #313151 !important;
    }

    .react-calendar__navigation button:focus {
      background: #313151 !important;
    }
    .react-calendar__navigation button:active {
      background: #313151 !important;
    }
`;

const CustomDateRangePicker = ({ value, onChange, minDate, maxDate }) => (
  <PickerWrapper>
    <DateRangePicker
      onChange={onChange}
      value={value}
      minDate={minDate}
      maxDate={maxDate}
      calendarIcon={null}
      clearIcon={null}
      format="MM/dd/yyyy"
      rangeDivider="-"
      calendarAriaLabel="Toggle calendar"
      dayPlaceholder="dd"
      monthPlaceholder="MM"
      yearPlaceholder="yyyy"
      showLeadingZeros={true}
      required={false}
    />
  </PickerWrapper>
);

export default CustomDateRangePicker;
